<template>
  <div class="component">
    <transition name="slide" v-on:enter="enter" v-on:leave="leave">
      <div
        class="veil"
        v-if="veil.active"
        v-bind:class="{ 'is-active': veil.active }"
      >
        <div class="container" v-if="veil.type === 'group'">
          <div class="row wrapper">
            <div class="d-none d-xl-block col-xl-3">
              <div v-if="typeof promos[index] !== 'undefined'" ref="promos">
                <h3 style="margin-bottom: 0.5rem">{{ promos[index].name }}</h3>
                <p v-html="promos[index].intro" style="margin-right: 1rem"></p>
                <a
                  v-bind:href="promos[index].href"
                  v-bind:target="promos[index].target"
                  class="btn cta-plain text-red icon right-arrow"
                  @click="onPromoClick(promos[index])"
                  >{{ promos[index].cta }}</a
                >
              </div>
            </div>
            <div class="col-xl-9">
              <div class="groups" ref="groups">
                <ul v-for="items in veil.group">
                  <li
                    v-for="item in items"
                    v-bind:class="{
                      'group-title': item.href === '##',
                      'no-padding': item.name === '',
                    }"
                  >
                    <a
                      v-bind:href="item.href"
                      v-bind:target="item.target || '_self'"
                      @click="onDropdownItemClick(item)"
                      >{{ item.name }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="container" v-if="veil.type === 'search'">
          <div class="row wrapper">
            <div class="col-xl-12">
              <div ref="search">
                <search-form></search-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-2 col-xl-1">
          <a :href="siteUrl" class="resmed-brand position-relative" style="z-index: 1;" target="_self"></a>
        </div>
        <div class="col-lg-10 col-xl-11">
          <nav>
            <div class="items">
              <ul>
                <li v-for="(item, index) in items">
                  <a
                    v-if="item.children"
                    v-bind:href="item.href"
                    v-on:mouseover="showGroup(item.children, index)"
                    v-on:mouseleave="veil.mouseover = false"
                    @click="onTopNavClick(item, index)"
                    >{{ item.name }}</a
                  >
                  <a
                    v-else
                    v-bind:href="item.href"
                    v-bind:target="item.target || '_self'"
                    @click="onTopNavClick(item, index)"
                    >{{ item.name }}</a
                  >
                </li>
              </ul>
              <a
                href="#"
                v-if="showLinks"
                v-on:mouseover="showSearch()"
                v-on:mouseleave="veil.mouseover = false"
                class="btn cta-pill icon filled-red search ctaButton"
                :class="{
                  active: veil.type === 'search' && veil.active,
                  disabled: searchDisabled,
                }"
                >{{ $getTranslation("Search", $route.params.region)}}</a
              >
              <a
                v-if="search === 'icon'"
                href="#"
                v-on:mouseover="showSearch()"
                v-on:mouseleave="veil.mouseover = false"
                class="navigation-icon search"
                :class="{
                  active: veil.type === 'search' && veil.active,
                  disabled: searchDisabled,
                }"
              ></a>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import { mapState } from 'vuex';
import { track_menu_click } from "../../analytics/events";

export default {
  name: "header-items-lg-xl",
  props: ["items", "promos", "search"],
  data() {
    return {
      index: 0,
      searchDisabled: false,
      veil: {
        type: undefined,
        mouseover: false,
        active: false,
        expanded: false,
        group: [],
        el: undefined,
        height: 0,
      },
      siteUrl: "https://www.resmed.com",
      siteRegion: ""
    };
  },
  mounted() {
    this.isUk();
  },
  methods: {
    // ── Analytics helpers ──────────────────────────────────────────
    onTopNavClick(item, position) {
      // Skip group-title anchors (href === '##')
      if (!item.href || item.href === "##") return;
      track_menu_click({
        clicked_area: "header",
        component_name: "header-items-lg-xl",
        component_variant: "desktop",
        navigation_level_1: item.name,
        navigation_depth: 1,
        clicked_text: item.name,
        clicked_url: item.href,
        position,
      });
    },
    onDropdownItemClick(item) {
      if (!item.href || item.href === "##") return;
      // Find the parent nav item name for level_1
      const parentItem = this.items[this.index];
      track_menu_click({
        clicked_area: "header",
        component_name: "header-items-lg-xl",
        component_variant: "desktop-dropdown",
        navigation_level_1: parentItem ? parentItem.name : "",
        navigation_level_2: item.name,
        navigation_depth: 2,
        clicked_text: item.name,
        clicked_url: item.href,
      });
    },
    onPromoClick(promo) {
      track_menu_click({
        clicked_area: "header",
        component_name: "header-items-lg-xl",
        component_variant: "desktop-promo",
        navigation_level_1: promo.name,
        navigation_depth: 1,
        clicked_text: promo.cta,
        clicked_url: promo.href,
      });
    },
    // ── Existing methods ───────────────────────────────────────────
    debounce: debounce(function (type, group, index) {
      if (!this.veil.mouseover) {
        return;
      }

      this.veil.active = true;
      this.veil.type = type;
      this.index = index;

      let items = Object.assign([], group);
      let arr = [],
        $i = -1;

      for (let value of items) {
        if (value.href === "##") {
          $i += 1;
          arr.push([]);
          arr[$i].push(value);
        } else {
          arr[$i] && arr[$i].push(value);
        }
      }

      this.veil.group = arr;

      this.$emit("on-search-active-changed", this.veil.type === "search");

      this.$nextTick(() => {
        if (this.veil.type === "search") {
          this.veil.height = this.$refs.search.offsetHeight;
        } else {
          if (typeof this.$refs.promos !== "undefined") {
            this.veil.height =
              this.$refs.promos.offsetHeight > this.$refs.groups.offsetHeight
                ? this.$refs.promos.offsetHeight
                : this.$refs.groups.offsetHeight;
          } else {
            this.veil.height = this.$refs.groups.offsetHeight;
          }
        }

        if (this.veil.expanded) {
          let height = `${this.veil.height + 200}px`;
          this.anime(this.veil.el, undefined, height);
        }
      });
    }, 300),
    showGroup(group, index) {
      this.veil.mouseover = true;
      this.debounce("group", group, index);
    },
    showSearch() {
      if (this.searchDisabled) {
        return;
      }
      this.veil.mouseover = true;
      this.debounce("search", [], this.items.length);
    },
    anime(el, done, height) {
      anime({
        targets: el,
        height: height,
        duration: this.veil.type === "search" ? 300 : 600,
        easing: "easeOutQuad",
      }).finished.then(() => {
        this.veil.expanded = !!height;
        done && done();
      });
    },
    enter(el, done) {
      this.veil.el = el;
      this.$nextTick(() => {
        let height = `${this.veil.height + 200}px`;
        this.anime(el, done, [0, height]);
      });
    },
    leave(el, done) {
      this.anime(el, done, 0);
    },
    isUk() {
      this.siteUrl = `/${this.$route.params.region}`;
      this.siteRegion = this.$route.params.region;
    },
  },
  created() {
    let arr = location.pathname.split("/").filter(function (e) {
        return e;
      }),
      site = arr[1];

    this.site = site;

    bus.$on("navigation:mouseleave", () => {
      this.veil.active = false;
    });

    bus.$on("navigation:desktop-click-outside", () => {
      this.veil.active = false;
    });

    bus.$on("navigation:search-disabled", (disabled) => {
      this.searchDisabled = !!disabled;
    });
  },
  computed: {
    ...mapState(['showLinks'])
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/components/navigation";

.component {
  .container {
    padding-top: 2.75rem;
    padding-bottom: 0.625rem;
    background-color: transparent;
  }

  .search {
    &[class*="pill"] {
      padding: 0.925rem 3rem 0.925rem 2rem;
      background-size: 0.73rem 0.73rem !important;

      &:hover,
      &.active,
      &.disabled {
        color: $cc-resmed-white;
        background-color: $cc-resmed-grey-30;
      }
    }
  }

  .veil {
    position: absolute;
    width: 100vw;
    overflow: hidden;

    &.is-active {
      background-color: $cc-resmed-white;

      ~ .container {
        nav ul li {
          a {
            transition: all 0.6s;
            color: $cc-resmed-grey-70;
          }
        }
      }
    }

    .wrapper {
      padding-top: 7rem;
    }

    .groups {
      display: flex;

      > ul {
        width: 50%;
        max-width: 300px;

        &:first-child {
          margin-right: 5rem;
        }

        li {
          a {
            line-height: inherit;
            padding: 0.625rem 0;
          }
        }
      }
    }

    .group-title {
      border-bottom: none;
      background-image: none;

      transform: translateY(-1.1925rem);
      padding-top: 1.5rem;

      @extend %h-dash;
      &:after {
        border-top-color: $cc-resmed-dark-grey;
        width: 1.25rem;
      }

      &.no-padding {
        padding: 0 !important;
      }

      a {
        @extend %body-normal;
        text-transform: uppercase;
        color: $cc-resmed-grey-70;
        padding: 0 !important;

        &:hover,
        &:focus {
          cursor: default;
          opacity: 1;
        }
      }
    }

    ul {
      li {
        @extend %default-list-style;
        padding-right: 1rem;

        a {
          font-size: 0.875rem;
          padding: 0.825rem 0;
        }
      }
    }
  }

  nav {
    animation: fade-in 2s ease;

    ul {
      list-style: none;
      display: flex;
      justify-content: flex-end;
      flex-wrap: nowrap;

      li {
        margin-right: 1.5rem;

        @media (min-width: 1200px) {
          margin-right: 1.8125rem;
        }

        a {
          @extend %navigation;
          color: $cc-resmed-white;

          transition: opacity 0.5s;

          &:hover {
            opacity: 0.5;
          }
        }
      }
    }

    .items {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: flex-end;
      transform: translateY(-1.5rem);
    }
  }

  .resmed-brand {
    display: block;

    width: 154px;
    height: 32px;

    margin: 0;

    margin-left: 1.5rem;
    transform: translateY(-1.5rem);
    background-image: url(#{$assets}/images/logo-white.png);

    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
  }
}
</style>